import { Button, Stack } from '@chakra-ui/react';
import React, { useState } from 'react';
import { MdUpload } from 'react-icons/md';

import { Header } from '@/components/ui/Header/Header';
import { Breadcrumbs } from '@/components/ui/Navigation/Breadcrumbs';
import { createRolesHook } from '@/hooks/useRoles';
import { Breadcrumb } from '@/types/Breadcrumbs';

import { useGetSettlementImportsQuery } from '../api';
import { MonthYearPicker, SettlementImportsList, SettlementImportUploadModal } from '../components';

const useRoles = createRolesHook(['user', 'admin']);

const breadcrumbs: Breadcrumb[] = [
  {
    path: '/app/settlementImports',
    displayValue: 'Import rozliczeń',
    isCurrentRoute: true,
  },
];

export const SettlementImportsPage = () => {
  const currentDate = new Date();
  const [selectedMonth, setSelectedMonth] = useState(currentDate.getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(currentDate.getFullYear());
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);

  useRoles();

  const { data, isLoading } = useGetSettlementImportsQuery({
    month: selectedMonth,
    year: selectedYear,
  });

  return (
    <Stack spacing={6}>
      <Breadcrumbs breadcrumbs={breadcrumbs} />

      <Header pb={4}>Import rozliczeń</Header>

      <Stack
        direction={{ base: 'column', md: 'row' }}
        spacing={4}
        align={{ base: 'stretch', md: 'center' }}
        justify="space-between"
        mb={6}
      >
        <MonthYearPicker
          month={selectedMonth}
          year={selectedYear}
          onMonthChange={setSelectedMonth}
          onYearChange={setSelectedYear}
        />
        <Button
          colorScheme="purple"
          leftIcon={<MdUpload />}
          onClick={() => setIsUploadModalOpen(true)}
          width={{ base: '100%', md: 'auto' }}
        >
          Dodaj nowy plik MT940
        </Button>
      </Stack>

      <SettlementImportsList
        imports={data?.items || []}
        isLoading={isLoading}
        selectedMonth={selectedMonth}
        selectedYear={selectedYear}
      />

      <SettlementImportUploadModal
        isOpen={isUploadModalOpen}
        onClose={() => setIsUploadModalOpen(false)}
      />
    </Stack>
  );
};
